import { apiFetch } from './api';

const API_URL = import.meta.env.VITE_API_URL || '';

/** O papel é o que decide comportamento — o nome e o id, não. Espelha `PapelEtapaEnum` da API. */
export const PAPEL = {
    roboAtendendo: 1,
    roboEncerrado: 2,
    miolo: 3,
    ganho: 4,
    perdido: 5,
} as const;

export interface EtapaFunil {
    id: number;
    nome: string;
    ordem: number;
    papel: number | null;
    negocios: number;
    entradaDoLead: boolean;
    /** Só o miolo. É o que a tela usa para decidir o que fica apagado e sem ação. */
    editavel: boolean;
}

interface Resposta<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

const corpo = async <T,>(resposta: Response): Promise<Resposta<T>> => {
    const dados = await resposta.json().catch(() => null);
    if (!resposta.ok || dados?.sucesso === false) {
        throw new Error(dados?.mensagem || 'Não foi possível falar com o servidor.');
    }
    return dados;
};

export const FunilService = {
    listar: async (): Promise<EtapaFunil[]> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil`, { method: 'GET' });
        const dados = await corpo<EtapaFunil[]>(resposta);
        return dados.dados ?? [];
    },

    criar: async (nome: string, depoisDaEtapaId?: number): Promise<void> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil/Etapas`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nome, depoisDaEtapaId: depoisDaEtapaId ?? null }),
        });
        await corpo(resposta);
    },

    renomear: async (etapaId: number, nome: string): Promise<void> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil/Etapas/${etapaId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nome }),
        });
        await corpo(resposta);
    },

    reordenar: async (etapasNaOrdem: number[]): Promise<void> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil/Ordem`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ etapasNaOrdem }),
        });
        await corpo(resposta);
    },

    excluir: async (etapaId: number, destinoId: number): Promise<string> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil/Etapas/${etapaId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ destinoId }),
        });
        const dados = await corpo<unknown>(resposta);
        return dados.mensagem;
    },

    definirEntradaDoLead: async (etapaId: number): Promise<void> => {
        const resposta = await apiFetch(`${API_URL}/api/Funil/Etapas/${etapaId}/EntradaDoLead`, { method: 'PUT' });
        await corpo(resposta);
    },
};
